// extracted by mini-css-extract-plugin
export default {"publicFooter":"PublicFooter_publicFooter__XJW7Q","footerLinks":"PublicFooter_footerLinks__xyXus"};